import   React        ,
       { useState     }  from 'react';

import   classNames      from 'classnames';

import   styles          from './ChatModeration.module.scss';

import { ChatModMessage ,
         ChatDecision   }  from '../../../dataTypes/moderationManagment/chat_types';

import { clockTime ,
         pct       }  from './chatModerationUi';

/**
 * Le fil des décisions : ce que voient les spectateurs (publiés) et ce qu'ils
 * ne voient pas (refusés), de l'IA comme de la régie. C'est ici qu'on rattrape
 * une erreur de l'IA : « Publier » un refus, « Retirer » un message publié.
 * Un message retiré disparaît pour les spectateurs qui arrivent ; ceux qui
 * l'ont déjà reçu le gardent à l'écran.
 */

type Filter = 'all' | 'approved' | 'rejected' | 'admin';

const FILTERS: { key: Filter; label: string }[] = [
  { key: 'all',      label: 'Tout'         },
  { key: 'approved', label: 'Publiés'      },
  { key: 'rejected', label: 'Refusés'      },
  { key: 'admin',    label: 'Par vous'     },
];

interface Props {
  recent      : ChatModMessage[];
  nameOf      : (channelId: number) => string;
  colorOf     : (channelId: number) => string;
  showChannel : boolean;
  onDecide    : (id: number, action: ChatDecision) => void;
}

const DecisionFeed: React.FC<Props> = ({ recent, nameOf, colorOf, showChannel, onDecide }) => {

  const [ filter, setFilter ] = useState<Filter>('all');

  const lines = recent.filter(m =>
    filter === 'all'      ? true :
    filter === 'admin'    ? m.moderatedBy === 'admin' :
                            m.status === filter);

  const rejectedCount = recent.filter(m => m.status === 'rejected').length;

  return (
    <section className={classNames(styles.panel, styles.feed)} aria-label="Fil des décisions">

      <header className={styles.panelHead}>
        <span className={styles.panelTitle}>Fil du chat</span>
        <span className={styles.spacer} />
        <span className={styles.muted} style={{ fontSize: 13 }}>2 dernières heures</span>
      </header>

      <div className={styles.feedFilters} role="tablist">
        {FILTERS.map(f => (
          <button key={f.key} type="button" role="tab" aria-selected={filter === f.key}
                  className={classNames(styles.filter, filter === f.key && styles.filterOn)}
                  onClick={() => setFilter(f.key)}>
            {f.label}{f.key === 'rejected' && rejectedCount > 0 ? ` ${rejectedCount}` : ''}
          </button>
        ))}
      </div>

      <div className={styles.feedList}>
        {lines.length === 0 && (
          <p className={styles.drawerText}>
            {recent.length === 0 ? "Aucun message ces deux dernières heures sur les chaînes suivies." : 'Aucun message dans ce filtre.'}
          </p>
        )}
        {lines.map(m => {
          const approved = m.status === 'approved';
          return (
            <div key={m.id} className={styles.line} style={{ ['--chan' as any]: colorOf(m.channelId) }}>
              <span className={styles.lineBar} />
              <div>
                <div className={styles.lineHead}>
                  <span className={styles.lineTime}>{clockTime(m.creationDate)}</span>
                  <span className={styles.linePseudo}>{m.pseudo}</span>
                  {showChannel && <span className={styles.faint}>· {nameOf(m.channelId)}</span>}
                  <span className={classNames(styles.status, approved ? styles.statusOk : styles.statusBad)}
                        title={m.aiScore !== null ? `Score IA ${pct(m.aiScore)}` : 'Non noté par l\'IA'}>
                    {approved ? 'Publié' : 'Refusé'} · {m.moderatedBy === 'admin' ? 'vous' : 'IA'}
                  </span>
                </div>
                <div className={classNames(styles.lineText, !approved && styles.lineRejected)}>{m.text}</div>
              </div>
              <button type="button" className={classNames(styles.btn, styles.btnSmall, styles.lineAction,
                                                          approved ? styles.btnReject : styles.btnApprove)}
                      onClick={() => onDecide(m.id, approved ? 'reject' : 'approve')}>
                {approved ? 'Retirer' : 'Publier'}
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default DecisionFeed;
